import { createReducer } from 'redux-act';
import actions from '../actions/employeeActions';

const initialState = {

  getEmployeeForReportingManagerPending: false,
  getEmployeeForReportingManagerRes: null,
  getEmployeeForReportingManagerError: null,

  getAllEmployeePending: false,
  getAllEmployeeRes: null,
  getAllEmployeeError: null,

  createEmployeePending: false,
  createEmployeeRes: null,
  createEmployeeError: null,

  getUserOnRolePending: false,
  getUserOnRoleRes: null,
  getUserOnRoleError: null,

  getProfilePending: false,
  getProfileRes: null,
  getProfileError: null,

  aadhaarVerifyPending: false,
  aadhaarVerifyRes: null,
  aadhaarVerifyError: null,

  getAllEmployeeListPending: false,
  getAllEmployeeListRes: null,
  getAllEmployeeListError: null,

  updateEmployeeDetailsPending: false,
  updateEmployeeDetailsRes: null,
  updateEmployeeDetailsError: null,

  bulkUpdateEmployeePending: false,
  bulkUpdateEmployeeRes: null,
  bulkUpdateEmployeeError: null,

  resumeParserPending: false,
  resumeParserRes: null,
  resumeParserError: null,

  generateEmployeeIdPending: false,
  generateEmployeeIdRes: null,
  generateEmployeeIdError: null,


  getEmployeeByDepartmentPending: false,
  getEmployeeByDepartmentRes: null,
  getEmployeeByDepartmentError: null,


  getEmployeeHistoryPending: false,
  getEmployeeHistoryRes: null,
  getEmployeeHistoryError: null,

  sendEmployeeCredentialsPending: false,
  sendEmployeeCredentialsRes: null,
  sendEmployeeCredentialsError: null,
  
  uploadProfilePending: false,
  uploadProfileRes: null,
  uploadProfileError: null,

  employeeDetailsData: null,
  selectedEmployeeData: null,
  selectedCandidateData: null,
};

/* Get Employee For Reporting Manager Reducers*/
const handleGetEmployeeForReportingManagerRequest = state1 => {
  return {
    ...state1,
    ...{
      getEmployeeForReportingManagerPending: true,
      getEmployeeForReportingManagerRes: null,
      getEmployeeForReportingManagerError: null,
    },
  };
};
const handleGetEmployeeForReportingManagerSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getEmployeeForReportingManagerPending: false,
      getEmployeeForReportingManagerRes: payload,
      getEmployeeForReportingManagerError: null,
    },
  };
};
const handleGetEmployeeForReportingManagerError = (state1, payload) => ({
  ...state1,
  ...{
    getEmployeeForReportingManagerPending: false,
    getEmployeeForReportingManagerRes: null,
    getEmployeeForReportingManagerError: payload,
  },
});


/* Get All Employee Reducers */
const handleGetAllEmployeeRequest = state1 => {
  return {
    ...state1,
    ...{
      getAllEmployeePending: true,
      getAllEmployeeRes: null,
      getAllEmployeeError: null,
    },
  };
};
const handleGetAllEmployeeSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAllEmployeePending: false,
      getAllEmployeeRes: payload,
      getAllEmployeeError: null,
    },
  };
};
const handleGetAllEmployeeError = (state1, payload) => ({
  ...state1,
  ...{
    getAllEmployeePending: false,
    getAllEmployeeRes: null,
    getAllEmployeeError: payload,
  },
});

/* Get User On Role Reducers */
const handleGetUserOnRoleRequest = state1 => {
  return {
    ...state1,
    ...{
      getUserOnRolePending: true,
      getUserOnRoleRes: null,
      getUserOnRoleError: null,
    },
  };
};
const handleGetUserOnRoleSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getUserOnRolePending: false,
      getUserOnRoleRes: payload,
      getUserOnRoleError: null,
    },
  };
};
const handleGetUserOnRoleError = (state1, payload) => ({
  ...state1,
  ...{
    getUserOnRolePending: false,
    getUserOnRoleRes: null,
    getUserOnRoleError: payload,
  },
});


/* Get Profile Reducers */
const handleGetProfileRequest = state1 => {
  return {
    ...state1,
    ...{
      getProfilePending: true,
      getProfileRes: null,
      getProfileError: null,
    },
  };
};
const handleGetProfileSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getProfilePending: false,
      getProfileRes: payload,
      getProfileError: null,
    },
  };
};
const handleGetProfileError = (state1, payload) => ({
  ...state1,
  ...{
    getProfilePending: false,
    getProfileRes: null,
    getProfileError: payload,
  },
});


/* aadhaar verify Reducers */
const handleAadhaarVerifyRequest = state1 => {
  return {
    ...state1,
    ...{
      aadhaarVerifyPending: true,
      aadhaarVerifyRes: null,
      aadhaarVerifyError: null,
    },
  };
};
const handleAadhaarVerifySuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      aadhaarVerifyPending: false,
      aadhaarVerifyRes: payload,
      aadhaarVerifyError: null,
    },
  };
};
const handleAadhaarVerifyError = (state1, payload) => ({
  ...state1,
  ...{
    aadhaarVerifyPending: false,
    aadhaarVerifyRes: null,
    aadhaarVerifyError: payload,
  },
});

/* Clear Employee Store Reducers */
const clearEmployeeStore = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR_GET_EMPLOYEE_FOR_REPORTING_MANAGER_STORE':
      return {
        ...state,
        ...{
          getEmployeeForReportingManagerPending: false,
          getEmployeeForReportingManagerRes: null,
          getEmployeeForReportingManagerError: null,
        },
      };
    default:
      return state;
  }
};

// create employee by admin
const handlecreateEmployeeRequest = state1 => {
  return {
    ...state1,
    ...{
      createEmployeePending: true,
      createEmployeeRes: null,
      createEmployeeError: null,
    },
  };
};
const handlecreateEmployeeSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      createEmployeePending: false,
      createEmployeeRes: payload,
      createEmployeeError: null,
    },
  };
};
const handlecreateEmployeeError = (state1, payload) => ({
  ...state1,
  ...{
    createEmployeePending: false,
    createEmployeeRes: null,
    createEmployeeError: payload,
  },
});


/* Get All Employee List Reducers */
const handleGetAllEmployeeListRequest = state1 => {
  return {
    ...state1,
    ...{
      getAllEmployeeListPending: true,
      getAllEmployeeListRes: null,
      getAllEmployeeListError: null,
    },
  };
};
const handleGetAllEmployeeListSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAllEmployeeListPending: false,
      getAllEmployeeListRes: payload,
      getAllEmployeeListError: null,
    },
  };
};
const handleGetAllEmployeeListError = (state1, payload) => ({
  ...state1,
  ...{
    getAllEmployeeListPending: false,
    getAllEmployeeListRes: null,
    getAllEmployeeListError: payload,
  },
});

/* update Employee Details Reducers */
const handleUpdateEmployeeDetailsRequest = state1 => {
  return {
    ...state1,
    ...{
      updateEmployeeDetailsPending: true,
      updateEmployeeDetailsRes: null,
      updateEmployeeDetailsError: null,
    },
  };
};
const handleUpdateEmployeeDetailsSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      updateEmployeeDetailsPending: false,
      updateEmployeeDetailsRes: payload,
      updateEmployeeDetailsError: null,
    },
  };
};
const handleUpdateEmployeeDetailsError = (state1, payload) => ({
  ...state1,
  ...{
    updateEmployeeDetailsPending: false,
    updateEmployeeDetailsRes: null,
    updateEmployeeDetailsError: payload,
  },
});

/* Bulk upload employee Reducers */
const handleBulkUpdateEmployeeRequest = state1 => {
  return {
    ...state1,
    ...{
      bulkUpdateEmployeePending: true,
      bulkUpdateEmployeeRes: null,
      bulkUpdateEmployeeError: null,
    },
  };
};
const handleBulkUpdateEmployeeSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      bulkUpdateEmployeePending: false,
      bulkUpdateEmployeeRes: payload,
      bulkUpdateEmployeeError: null,
    },
  };
};
const handleBulkUpdateEmployeeError = (state1, payload) => ({
  ...state1,
  ...{
    bulkUpdateEmployeePending: false,
    bulkUpdateEmployeeRes: null,
    bulkUpdateEmployeeError: payload,
  },
});

/* Resume Parser Reducers */
const handleResumeParserRequest = state1 => {
  return {
    ...state1,
    ...{
      resumeParserPending: true,
      resumeParserRes: null,
      resumeParserError: null,
    },
  };
};
const handleResumeParserSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      resumeParserPending: false,
      resumeParserRes: payload,
      resumeParserError: null,
    },
  };
};
const handleResumeParserError = (state1, payload) => ({
  ...state1,
  ...{
    resumeParserPending: false,
    resumeParserRes: null,
    resumeParserError: payload,
  },
});


/* Employee Details Reducers */
const handleEmployeeDetails = (state1, payload) => ({
  ...state1,
  ...{
    employeeDetailsData: payload,
  }

});

/* Employee Details Reducers */
const handleSelectedEmployeeData = (state1, payload) => ({
  ...state1,
  ...{
    selectedEmployeeData: payload,
  }

});

/* Employee Details Reducers */
const handleSelectedCandidateData = (state1, payload) => ({
  ...state1,
  ...{
    selectedCandidateData: payload,
  }

});

/* Get Generate Employee Id Reducers*/
const handleGenerateEmployeeIdRequest = state1 => {
  return {
    ...state1,
    ...{
      generateEmployeeIdPending: true,
      generateEmployeeIdRes: null,
      generateEmployeeIdError: null,
    },
  };
};
const handleGetGenerateEmployeeIdSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      generateEmployeeIdPending: false,
      generateEmployeeIdRes: payload,
      generateEmployeeIdError: null,
    },
  };
};
const handleGenerateEmployeeIdError = (state1, payload) => ({
  ...state1,
  ...{
    generateEmployeeIdPending: false,
    generateEmployeeIdRes: null,
    generateEmployeeIdError: payload,
  },
});

/* Get Generate Employee Id Reducers*/
const handleGetEmployeeByDepartmentRequest = state1 => {
  return {
    ...state1,
    ...{
      getEmployeeByDepartmentPending: true,
      getEmployeeByDepartmentRes: null,
      getEmployeeByDepartmentError: null,
    },
  };
};
const handleGetEmployeeByDepartmentSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getEmployeeByDepartmentPending: false,
      getEmployeeByDepartmentRes: payload,
      getEmployeeByDepartmentError: null,
    },
  };
};
const handleGetEmployeeByDepartmentError = (state1, payload) => ({
  ...state1,
  ...{
    getEmployeeByDepartmentPending: false,
    getEmployeeByDepartmentRes: null,
    getEmployeeByDepartmentError: payload,
  },
});

/* Get Generate Employee Id Reducers*/
const handleGetEmployeeHistoryRequest = state1 => {
  return {
    ...state1,
    ...{
      getEmployeeHistoryPending: true,
      getEmployeeHistoryRes: null,
      getEmployeeHistoryError: null,
    },
  };
};
const handleGetEmployeeHistorySuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getEmployeeHistoryPending: false,
      getEmployeeHistoryRes: payload,
      getEmployeeHistoryError: null,
    },
  };
};
const handleGetEmployeeHistoryError = (state1, payload) => ({
  ...state1,
  ...{
    getEmployeeHistoryPending: false,
    getEmployeeHistoryRes: null,
    getEmployeeHistoryError: payload,
  },
});


/* Get Generate Employee Id Reducers*/
const handleSendEmployeeCredentialsRequest = state1 => {
  return {
    ...state1,
    ...{
      sendEmployeeCredentialsPending: true,
      sendEmployeeCredentialsRes: null,
      sendEmployeeCredentialsError: null,
    },
  };
};
const handleSendEmployeeCredentialsSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      sendEmployeeCredentialsPending: false,
      sendEmployeeCredentialsRes: payload,
      sendEmployeeCredentialsError: null,
    },
  };
};
const handleSendEmployeeCredentialsError = (state1, payload) => ({
  ...state1,
  ...{
    sendEmployeeCredentialsPending: false,
    sendEmployeeCredentialsRes: null,
    sendEmployeeCredentialsError: payload,
  },
});


/* Uplaod Profile Reducers*/
const handleUploadProfileRequest = state1 => {
  return {
    ...state1,
    ...{
      uploadProfilePending: true,
      uploadProfileRes: null,
      uploadProfileError: null,
    },
  };
};
const handleUploadProfileSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      uploadProfilePending: false,
      uploadProfileRes: payload,
      uploadProfileError: null,
    },
  };
};
const handleUploadProfileError = (state1, payload) => ({
  ...state1,
  ...{
    uploadProfilePending: false,
    uploadProfileRes: null,
    uploadProfileError: payload,
  },
});





// clear existing data
const clearCreateEmployeeStore = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR_CREATE_EMPLOYEE_STORE':
      return {
        ...state,
        ...{
          createEmployeePending: false,
          createEmployeeRes: null,
          createEmployeeError: null,
        },
      };

    case 'HANDLE_CLEAR_UPDATE_EMPLOYEE_DETAILS_STORE':
      return {
        ...state,
        ...{
          updateEmployeeDetailsPending: false,
          updateEmployeeDetailsRes: null,
          updateEmployeeDetailsError: null,
        },
      };
    case 'HANDLE_CLEAR_BULK_UPDATE_EMPLOYEE_STORE':
      return {
        ...state,
        ...{
          bulkUpdateEmployeePending: false,
          bulkUpdateEmployeeRes: null,
          bulkUpdateEmployeeError: null,
        },
      };
    case 'HANDLE_CLEAR_GENERATE_EMPLOYEE_ID_STORE':
      return {
        ...state,
        ...{
          generateEmployeeIdPending: true,
          generateEmployeeIdRes: null,
          generateEmployeeIdError: null,
        },
      };

    case 'HANDLE_CLEAR_RESUME_PARSER_STORE':
      return {
        ...state,
        ...{
          resumeParserPending: false,
          resumeParserRes: null,
          resumeParserError: null,
        },
      };
    case 'HANDLE_CLEAR_SEND_EMPLOYEE_CREDENTIALS_STORE':
      return {
        ...state,
        ...{
          sendEmployeeCredentialsPending: false,
          sendEmployeeCredentialsRes: null,
          sendEmployeeCredentialsError: null,
        },
      };
    case 'HANDLE_CLEAR_UPLOAD_STORE':
      return {
        ...state,
        ...{
          uploadProfilePending: false,
          uploadProfileRes: null,
          uploadProfileError: null,
        },
      };
    case 'HANDLE_CLEAR_CANDIDATE_DATA_STORE':
      return {
        ...state,
        ...{
          selectedCandidateData: null,
        },
      };
    default:
      return state;
  }
};

export default createReducer(
  {

    [actions.getEmployeeForReportingManagerRequest]: handleGetEmployeeForReportingManagerRequest,
    [actions.getEmployeeForReportingManagerSuccess]: handleGetEmployeeForReportingManagerSuccess,
    [actions.getEmployeeForReportingManagerError]: handleGetEmployeeForReportingManagerError,

    [actions.getAllEmployeeRequest]: handleGetAllEmployeeRequest,
    [actions.getAllEmployeeSuccess]: handleGetAllEmployeeSuccess,
    [actions.getAllEmployeeError]: handleGetAllEmployeeError,

    [actions.createEmployeeRequest]: handlecreateEmployeeRequest,
    [actions.createEmployeeSuccess]: handlecreateEmployeeSuccess,
    [actions.createEmployeeError]: handlecreateEmployeeError,

    [actions.handleClearEmployeeStore]: clearCreateEmployeeStore,

    [actions.getUserOnRoleRequest]: handleGetUserOnRoleRequest,
    [actions.getUserOnRoleSuccess]: handleGetUserOnRoleSuccess,
    [actions.getUserOnRoleError]: handleGetUserOnRoleError,

    [actions.getProfileRequest]: handleGetProfileRequest,
    [actions.getProfileSuccess]: handleGetProfileSuccess,
    [actions.getProfileError]: handleGetProfileError,

    [actions.aadhaarVerifyRequest]: handleAadhaarVerifyRequest,
    [actions.aadhaarVerifySuccess]: handleAadhaarVerifySuccess,
    [actions.aadhaarVerifyError]: handleAadhaarVerifyError,

    [actions.getAllEmployeeListRequest]: handleGetAllEmployeeListRequest,
    [actions.getAllEmployeeListSuccess]: handleGetAllEmployeeListSuccess,
    [actions.getAllEmployeeListError]: handleGetAllEmployeeListError,

    [actions.updateEmployeeDetailsRequest]: handleUpdateEmployeeDetailsRequest,
    [actions.updateEmployeeDetailsSuccess]: handleUpdateEmployeeDetailsSuccess,
    [actions.updateEmployeeDetailsError]: handleUpdateEmployeeDetailsError,

    [actions.bulkUpdateEmployeeRequest]: handleBulkUpdateEmployeeRequest,
    [actions.bulkUpdateEmployeeSuccess]: handleBulkUpdateEmployeeSuccess,
    [actions.bulkUpdateEmployeeError]: handleBulkUpdateEmployeeError,

    [actions.resumeParserRequest]: handleResumeParserRequest,
    [actions.resumeParserSuccess]: handleResumeParserSuccess,
    [actions.resumeParserError]: handleResumeParserError,

    [actions.generateEmployeeIdRequest]: handleGenerateEmployeeIdRequest,
    [actions.generateEmployeeIdSuccess]: handleGetGenerateEmployeeIdSuccess,
    [actions.generateEmployeeIdError]: handleGenerateEmployeeIdError,

    [actions.getEmployeeByDepartmentRequest]: handleGetEmployeeByDepartmentRequest,
    [actions.getEmployeeByDepartmentSuccess]: handleGetEmployeeByDepartmentSuccess,
    [actions.getEmployeeByDepartmentError]: handleGetEmployeeByDepartmentError,

    [actions.getEmployeeHistoryRequest]: handleGetEmployeeHistoryRequest,
    [actions.getEmployeeHistorySuccess]: handleGetEmployeeHistorySuccess,
    [actions.getEmployeeHistoryError]: handleGetEmployeeHistoryError,

    [actions.sendEmployeeCredentialsRequest]: handleSendEmployeeCredentialsRequest,
    [actions.sendEmployeeCredentialsSuccess]: handleSendEmployeeCredentialsSuccess,
    [actions.sendEmployeeCredentialsError]: handleSendEmployeeCredentialsError,

    [actions.uploadProfileRequest]: handleUploadProfileRequest,
    [actions.uploadProfileSuccess]: handleUploadProfileSuccess,
    [actions.uploadProfileError]: handleUploadProfileError,

    [actions.employeeDetails]: handleEmployeeDetails,
    [actions.selectedEmployeeData]: handleSelectedEmployeeData,
    [actions.selectedCandidateData]: handleSelectedCandidateData
  },
  initialState,
);
